import axios, { AxiosInstance, AxiosRequestConfig, Method } from "axios";
import qs from "query-string";

import { getAPIUrl } from "utils/networking";

const getToken = (): string | null => localStorage.getItem("token");

const axiosInstance: AxiosInstance = axios.create({
  baseURL: getAPIUrl(),
  headers: {
    "Content-Type": "application/json",
    Accept: "*/*",
  },
});

axiosInstance.interceptors.request.use((config: AxiosRequestConfig) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use((response) => response);

const fetchData = async <T>(method: Method, url: string, body?: Record<string, unknown>): Promise<T> => {
  const response = await axiosInstance.request<T>({ method, url, data: body });
  return response.data;
};

const getData = async <T>(url: string, body?: Record<string, unknown>, baseURL?: string): Promise<T> => {
  axiosInstance.defaults.baseURL = baseURL || getAPIUrl();
  const response = await axiosInstance.get<T>(url, { params: body });

  return response.data;
};

export const get = <T>(url: string, data?: Record<string, unknown>, baseURL?: string): Promise<T> =>
  getData<T>(url, data, baseURL);

export const getList = async <T>(url: string, params?: Record<string, any>): Promise<{ data: T[]; total: number }> => {
  const queryString = params ? `?${qs.stringify(params)}` : "";
  const response = await axiosInstance.get<T[]>(`${url}${queryString}`);
  const contentRange = response.headers["content-range"];
  let total = 0;
  if (contentRange) {
    const match = contentRange.match(/\/(\d+)$/);
    if (match) total = parseInt(match[1], 10);
  } else {
    total = response.data.length;
  }
  return { data: response.data, total };
};

export const post = <T>(url: string, body: Record<string, unknown>): Promise<T> => fetchData<T>("POST", url, body);

export const put = <T>(url: string, body: Record<string, unknown>): Promise<T> => fetchData<T>("PUT", url, body);

export const destroy = <T>(url: string): Promise<T> => fetchData<T>("DELETE", url);
